"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSquare = void 0;
exports.stringAvatar = stringAvatar;
const initials_1 = __importDefault(require("initials"));
function stringToColor(string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
        hash = (string.codePointAt(i) || 0) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}
// we want to return same bgcolor if the initials are the same
const initialColors = new Map();
function stringAvatar(name) {
    const children = (0, initials_1.default)(name).slice(0, 3);
    let bgcolor = initialColors.get(children);
    if (!bgcolor) {
        bgcolor = stringToColor(name);
        initialColors.set(children, bgcolor);
    }
    return {
        sx: {
            bgcolor: bgcolor || '',
        },
        children,
    };
}
const DEFAULT_AVATAR_SIZE = 145;
const getSquare = (src, size = DEFAULT_AVATAR_SIZE) => {
    if (!src || !size) {
        return '';
    }
    const filename = src.split('/').pop();
    return src.replace(/upload\/.*/, `upload/w_${size},h_${size},c_fill/${filename}`);
};
exports.getSquare = getSquare;
